import React, { useEffect, useState } from "react";
import {
  Button,
  Divider,
  Grid,
  Typography,
  Autocomplete as Selectbox,
} from "@mui/material";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import ParentCard from "src/components/shared/ParentCard";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
import swal from "sweetalert";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
import { IconArrowBack } from "@tabler/icons";
import {
  Autocomplete,
  GoogleMap,
  Marker,
  Circle,
} from "@react-google-maps/api";
import VehicleDetailsService from "src/service/vehicleDetails";
import GeofencingSetupService from "src/service/geofenceSetup";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Add Restricted Area",
  },
];

const validationSchema = yup.object({
  location_name: yup
    .string("Enter Location name")
    .required("Location Name is required"),
  vehicle_no: yup
    .string("Select vehicle No")
    .required("Vehicle No is required"),
  radius: yup
    .string("Enter Radius in km")
    .matches(/^[0-9.]{1,6}$/, "Invalid Radius")
    .required("Radius is Required"),
  alert_status: yup
    .string("Select Alert status")
    .required("Alert status is required"),
});

const AddRestrictedAreaList = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const [starting_place_name, setStarting_place_name] = useState("");
  const [starting_latitude, setStarting_latitude] = useState("");
  const [starting_longitude, setStarting_longitude] = useState("");

  // eslint-disable-next-line no-unused-vars
  const [payload, setPayload] = useState([]);

  const [startMarker, setStartMarker] = useState({
    position: { lat: 23.876536, lng: 85.876453 },
    address: "",
  });

  const [endMarker, setEndMarker] = useState({
    position: { lat: 23.876536, lng: 85.876453 },
    address: "",
  });

  const onAutocompleteLoadStart = (autocomplete) => {
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();

      if (place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        setStartMarker({
          position: { lat, lng },
          address: place.formatted_address,
        });

        setStarting_place_name(place.formatted_address);
        setStarting_latitude(lat);
        setStarting_longitude(lng);
      }
    });
  };

  const calculateEndingCoordinates = (startLat, startLng, distance) => {
    // Use appropriate formulas to calculate the new coordinates
    // For simplicity, let's assume a circular geofencing area
    const endingLat = startLat + distance / 111.32; // 1 degree of latitude is approximately 111.32 km
    const endingLng = startLng;

    return { lat: endingLat, lng: endingLng };
  };

  const [vehicle_list, setVehicle_list] = useState([]);

  const fetch_vehicle_list = async () => {
    try {
      const res = await VehicleDetailsService.fetch_distict_vehicle({
        vehicle_type: sessionData?.data?.vehicle_type || "",
        district_id: sessionData?.data?.district_id || "",
        user_type: sessionData?.data?.user_type || "",
        user_id: sessionData?.data?.id || "",
      });

      setVehicle_list(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const initialValues = {
    geo_fence_type: 3,
    vehicle_no: "",
    place_name: "",
    latitude: "",
    longitude: "",
    radius: "",
    email_id: "",
    alert_status: "",
    location_name: "",
    c_by: sessionData.data.id,
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: validationSchema,
      onSubmit: async (values) => {
        const payloadval = {
          geo_fence_type: 3,
          vehicle_no: values.vehicle_no,
          place_name: starting_place_name,
          latitude: starting_latitude,
          longitude: starting_longitude,
          radius: values.radius,
          email_id: values.email_id,
          alert_status: values.alert_status,
          location_name: values.location_name,
          c_by: sessionData.data.id,
        };
        console.log("payloadval===", payloadval);
        try {
          const res = await GeofencingSetupService.add_geofencing_data(
            payloadval
          );
          swal("success", res.message, "success");
          setPayload([]);
          setTimeout(() => {
            navigate("/restrictedarealist");
          }, 1000);
        } catch (error) {
          swal("error", error, "error");
        }
      },
    });

  const handleValuesChange = () => {
    if (starting_latitude && starting_longitude && values.radius) {
      const endingCoordinates = calculateEndingCoordinates(
        parseFloat(starting_latitude),
        parseFloat(starting_longitude),
        parseFloat(values.radius)
      );
      setEndMarker({
        position: endingCoordinates,
        address: `Geofencing Area (Radius: ${values.radius} km)`,
      });
    }
  };
  useEffect(() => {
    // Calculate and set coordinates for the ending place when starting place changes
    if (starting_latitude && starting_longitude && values.radius) {
      const endingCoordinates = calculateEndingCoordinates(
        parseFloat(starting_latitude),
        parseFloat(starting_longitude),
        parseFloat(values.radius)
      );
      setEndMarker({
        position: endingCoordinates,
        address: `Geofencing Area (Radius: ${values.radius} km)`,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleValuesChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [starting_latitude, starting_longitude, values.radius]);

  useEffect(() => {
    fetch_vehicle_list();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData.data.id, sessionData.data.user_type]);
  return (
    <>
      <Breadcrumb title="Geo Fencing" items={BCrumb} />
      <ParentCard title="" style={{ minHeight: "600px !important" }}>
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Add Home site Location
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/restrictedarealist");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "10px" }}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid item spacing={3} container lg={12} md={12} sm={12} xs={12}>
                <Grid
                  item
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor="vehicle_no">
                    Vehicle Number <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <Selectbox
                    id="vehicle_no"
                    name="vehicle_no"
                    options={vehicle_list}
                    // getOptionLabel={(option) => option.vehicle_no}
                    getOptionLabel={(option) => `${option.vehicle_no}`}
                    value={
                      vehicle_list.find(
                        (vehicle_list) =>
                          vehicle_list.vehicle_no === values.vehicle_no
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      handleChange({
                        target: {
                          name: "vehicle_no",
                          value: newValue?.vehicle_no || "",
                        },
                      });
                    }}
                    onBlur={handleBlur}
                    renderInput={(params) => (
                      <CustomTextField
                        {...params}
                        error={touched.vehicle_no && Boolean(errors.vehicle_no)}
                        helperText={touched.vehicle_no && errors.vehicle_no}
                        fullWidth
                        variant="outlined"
                        placeholder="Search or select a vehicle"
                      />
                    )}
                  />
                </Grid>

                <Grid
                  item
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor="end_pt_latitude">
                    Start Place Name <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <Autocomplete onLoad={onAutocompleteLoadStart}>
                    <CustomTextField
                      type="text"
                      onChange={handleChange}
                      onBlur={(event, newValue) => {
                        handleBlur(event);
                      }}
                      variant="outlined"
                      placeholder="Enter starting address"
                      fullWidth
                    />
                  </Autocomplete>
                </Grid>

                <Grid
                  item
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor="start_pt_latitude">
                    Latitude <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <CustomTextField
                    type="text"
                    value={starting_latitude}
                    variant="outlined"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </Grid>

                <Grid
                  item
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor="start_pt_longitude">
                    Longitude <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <CustomTextField
                    id="start_pt_longitude"
                    name="start_pt_longitude"
                    type="text"
                    value={starting_longitude}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    variant="outlined"
                    fullWidth
                    InputProps={{ readOnly: true }}
                  />
                </Grid>

                <Grid
                  item
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor="radius">
                    Radius (Km) <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <CustomTextField
                    id="radius"
                    name="radius"
                    type="text"
                    value={values.radius}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.radius && Boolean(errors.radius)}
                    helperText={touched.radius && errors.radius}
                    variant="outlined"
                    placeholder="Enter Radius in Km"
                    fullWidth
                  />
                </Grid>

                <Grid
                  item
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor="location_name">
                    Location Name <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <CustomTextField
                    id="location_name"
                    name="location_name"
                    type="text"
                    value={values.location_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.location_name && Boolean(errors.location_name)
                    }
                    helperText={touched.location_name && errors.location_name}
                    variant="outlined"
                    placeholder="Enter Location name"
                    fullWidth
                  />
                </Grid>

                <Grid
                  item
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor="email_id">
                    Email Id <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <CustomTextField
                    id="email_id"
                    name="email_id"
                    type="text"
                    value={values.email_id}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.email_id && Boolean(errors.email_id)}
                    helperText={touched.email_id && errors.email_id}
                    variant="outlined"
                    placeholder="Enter Email id"
                    fullWidth
                  />
                </Grid>

                <Grid
                  item
                  lg={4}
                  md={6}
                  sm={6}
                  xs={12}
                  style={{ marginTop: "-10px" }}
                >
                  <CustomFormLabel htmlFor="alert_status">
                    Send Alert <span style={{ color: "red" }}>*</span>
                  </CustomFormLabel>
                  <Selectbox
                    id="alert_status"
                    name="alert_status"
                    options={[
                      { label: "Yes", value: 1 },
                      { label: "No", value: 2 },
                    ]}
                    getOptionLabel={(option) => option.label}
                    value={
                      [
                        { label: "Yes", value: 1 },
                        { label: "No", value: 2 },
                      ].find(
                        (option) => option.value === values.alert_status
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      handleChange({
                        target: {
                          name: "alert_status",
                          value: newValue?.value || "",
                        },
                      });
                    }}
                    onBlur={handleBlur}
                    renderInput={(params) => (
                      <CustomTextField
                        {...params}
                        error={
                          touched.alert_status && Boolean(errors.alert_status)
                        }
                        helperText={touched.alert_status && errors.alert_status}
                        fullWidth
                        variant="outlined"
                        placeholder="Select Yes or No"
                      />
                    )}
                  />
                </Grid>
              </Grid>

              <GoogleMap
                mapContainerStyle={{
                  height: "400px",
                  width: "100%",
                  marginTop: "20px",
                }}
                zoom={10}
                center={startMarker.position}
              >
                {/* {directions && <DirectionsRenderer directions={directions} />} */}

                <Marker position={startMarker.position} />

                {/* Render the geofencing area as a circle */}
                {endMarker.position && (
                  <Circle
                    center={startMarker.position}
                    radius={parseFloat(values.radius) * 1000} // Keep radius in kilometers
                    options={{
                      strokeColor: "#73A5C6",
                      strokeOpacity: 0.8,
                      strokeWeight: 2,
                      fillColor: "#73A5C6",
                      fillOpacity: 0.35,
                    }}
                  />
                )}
              </GoogleMap>
            </Grid>
            <Grid item lg={12} md={12} sm={12}>
              <Button type="submit" color="success" variant="contained">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </>
  );
};

export default AddRestrictedAreaList;
